import { render, staticRenderFns } from "./FormElements.vue?vue&type=template&id=68f0b1f4"
import script from "./FormElements.vue?vue&type=script&lang=js"
export * from "./FormElements.vue?vue&type=script&lang=js"
import style0 from "./FormElements.vue?vue&type=style&index=0&id=68f0b1f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports